import { proxy } from "valtio";

import { StateLicense } from "types/stateLicense.types";
import { StateLicense as VerifiedStateLicenses } from "types/therapist.types";
import { Id } from "types";

import { TherapistCollectionService } from "./therapistCollectionService";

class StateLicenseService extends TherapistCollectionService<Id, StateLicense> {
  constructor(props?: any) {
    super({ ...props, collectionString: "/state-licenses" });
  }

  get verifiedStateLicenses(): VerifiedStateLicenses[] {
    return this.data
      .filter(
        (license) =>
          license.license_state && license.license_number && license.is_verified
      )
      .map((license) => ({
        state: license.license_state,
        number: license.license_number,
      }));
  }
}

export const stateLicenseService = proxy(new StateLicenseService());
